<template>
    <ContainerWithMenu>
        <div class="page-content">
            <h1 class="h2 margin-bottom-40">{{ $t('views.developers.title') }}</h1>
            <div class="margin-bottom-60">
                <h3>{{ $t('views.developers.username_title') }}</h3>
                <p class="margin-bottom-20">{{ $t('views.developers.username_content') }}</p>
                <div class="clearfix margin-bottom-20">
                    <div style="background-color:#f5f5f5;float:left;border-radius:6px;padding:12px 18px;">
                        <span class="text-muted">respira.yoga/</span><b>{{company.username}}</b>
                    </div>
                </div>
                <img style="width:100px;" :src="qrCodeLink"/>
            </div>
            <div class="margin-bottom-60">
                <h3>{{ $t('views.developers.calendar_title') }}</h3>
                <p class="margin-bottom-20">{{ $t('views.developers.calendar_content') }}</p>
                <div class="clearfix margin-bottom-20">
                    <div style="background-color:#f5f5f5;float:left;border-radius:6px;padding:12px 18px;">
                        <a :href="calendarLink" target="_blank">{{calendarLink}}</a>
                    </div>
                </div>
                <div
                        v-show="errorMessageCalendarCopy"
                        class="alert alert-danger"
                        role="alert"
                >
                    {{ errorMessageCalendarCopy }}
                </div>
                <div
                        v-show="successMessageCalendarCopy"
                        class="alert alert-success"
                        role="alert"
                >
                    {{ successMessageCalendarCopy }}
                </div>
                <button class="btn btn-default"
                        v-clipboard="() => calendarLink"
                        v-clipboard:success="successCalendarCopy"
                        v-clipboard:error="errorCalendarCopy">
                    <i class="las la-copy"></i>{{ $t('views.developers.calendar_copy_link') }}
                </button>
            </div>
            <div class="hide">
                <h3>Widget Prenotazione <span class="badge">Integrazione avanzata</span></h3>
                <p class="margin-bottom-20">Il widget prenotazione ti permette di mostrare il calendario all'interno del tuo sito internet. Copia il codice e inseriscilo all'interno dell'HTML del tuo sito. Il widget prenotazione richiede conoscenze informatiche.</p>
                <div class="clearfix margin-bottom-20">
                    <div style="background-color:#f5f5f5;border-radius:6px;padding:12px 18px;">
                         Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    </div>
                </div>
                <a class="btn btn-default" href=""><i class="las la-copy"></i>Copia codice widget</a>
            </div>
        </div>
        <SpinnerLoader v-show="loading"></SpinnerLoader>
    </ContainerWithMenu>
</template>

<script>
    import ContainerWithMenu from "../components/container/ContainerWithMenu";
    import SpinnerLoader from "../components/common/SpinnerLoader";
    import {getCompanyInfo} from "../api";
    import {URL_BOOKING} from "../common/constants";
    import i18n from "../i18n";

    export default {
        title: 'Sviluppatori',
        name: "Developers",
        data: () => {
            return {
                successMessageCalendarCopy: null,
                errorMessageCalendarCopy: null,
                company: {},
                loading: false
            }
        },
        components: { ContainerWithMenu, SpinnerLoader },
        computed: {
            calendarLink() {
              return URL_BOOKING + this.company.username
            },

            qrCodeLink() {
                return "http://api.qrserver.com/v1/create-qr-code/?color=000000&bgcolor=FFFFFF&data=https://respira.yoga/" + this.company.username + "&qzone=0&margin=0&size=600x600&ecc=L"
            }
        },
        methods: {
            successCalendarCopy() {
                this.successMessageCalendarCopy = i18n.t('views.developers.calendar_copy_success');
                this.errorMessageCalendarCopy = '';
            },
            errorCalendarCopy() {
                this.errorMessageCalendarCopy = i18n.t('views.developers.calendar_copy_fail');
                this.successMessageCalendarCopy = '';
            }
        },
        async mounted() {
            this.loading = true;
            this.errorMessage = "";
            try {
                this.company = await getCompanyInfo();
                this.loading = false;
            } catch (e) {
                this.loading = false;

            }
        },

    };
</script>
